// @ is an alias to /src
import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  configWorkingHours: {},
}

export const mutations = {
  SET_CONFIG_WORKING_HOURS(state, configWorkingHours) {
    state.configWorkingHours = configWorkingHours
  },
}

export const actions = {
  fetchConfigWorkingHours({ commit }, payload) {
    return ApiService.fetchConfigWorkingHours(payload)
      .then((res) => {
        const configWorkingHours = res.data
        commit('SET_CONFIG_WORKING_HOURS', configWorkingHours)
      })
      .catch((error) => {
        throw error
      })
  },
  editConfigWorkingHours({ commit }, payload) {
    return ApiService.editConfigWorkingHours(payload)
      .then((res) => {
        const configWorkingHours = res.data
        commit('SET_CONFIG_WORKING_HOURS', configWorkingHours)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchConfigWorkingHoursConstant() {
    return ApiService.fetchConfigWorkingHoursConstant()
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
}
